/* External dependencies */
import { ICognitoUserPoolData } from 'amazon-cognito-identity-js';

/* Local dependencies */

export enum ForgotPasswordActionTypes {
  FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST',
  FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR',
  CONFIRM_FORGOT_PASSWORD_REQUEST = 'CONFIRM_FORGOT_PASSWORD_REQUEST',
  CONFIRM_FORGOT_PASSWORD_SUCCESS = 'CONFIRM_FORGOT_PASSWORD_SUCCESS',
  CONFIRM_FORGOT_PASSWORD_ERROR = 'CONFIRM_FORGOT_PASSWORD_ERROR',
  SET_FORGOT_PASSWORD_FIELD = 'SET_FORGOT_PASSWORD_FIELD',
  VERIFY_CODE_REQUEST = 'VERIFY_CODE_REQUEST',
}

export interface ForgotPasswordRequest {
  type: ForgotPasswordActionTypes.FORGOT_PASSWORD_REQUEST;
  username: string;
  userPool: ICognitoUserPoolData;
  [key: string]: any;
}

export interface ForgotPasswordSuccess {
  type: ForgotPasswordActionTypes.FORGOT_PASSWORD_SUCCESS;
  username: string;
  [key: string]: any;
}

export interface ForgotPasswordError {
  type: ForgotPasswordActionTypes.FORGOT_PASSWORD_ERROR;
  error: any;
  [key: string]: any;
}

export interface ConfirmForgotPasswordRequest {
  type: ForgotPasswordActionTypes.CONFIRM_FORGOT_PASSWORD_REQUEST;
  username: string;
  verificationCode: string;
  newPassword: string;
  userPool: ICognitoUserPoolData;
  [key: string]: any;
}

export interface ConfirmForgotPasswordSuccess {
  type: ForgotPasswordActionTypes.CONFIRM_FORGOT_PASSWORD_SUCCESS;
  [key: string]: any;
}

export interface ConfirmForgotPasswordError {
  type: ForgotPasswordActionTypes.CONFIRM_FORGOT_PASSWORD_ERROR;
  error: any;
  [key: string]: any;
}

export interface SetForgotPasswordField {
  type: ForgotPasswordActionTypes.SET_FORGOT_PASSWORD_FIELD;
  field: 'email' | 'verificationCode' | 'newPassword' | 'confirmPassword';
  value: string;
  [key: string]: any;
}

export function forgotPassword(username: string, userPool: ICognitoUserPoolData): ForgotPasswordRequest {
  return {
    type: ForgotPasswordActionTypes.FORGOT_PASSWORD_REQUEST,
    username,
    userPool,
  } as ForgotPasswordRequest;
}

export function forgotPasswordSuccess(username: string): ForgotPasswordSuccess {
  return {
    type: ForgotPasswordActionTypes.FORGOT_PASSWORD_SUCCESS,
    username,
  } as ForgotPasswordSuccess;
}

export function forgotPasswordFailed(error: any): ForgotPasswordError {
  return {
    type: ForgotPasswordActionTypes.FORGOT_PASSWORD_ERROR,
    error,
  } as ForgotPasswordError;
}

export function confirmForgotPassword(
  username: string,
  verificationCode: string,
  newPassword: string,
  userPool: ICognitoUserPoolData
): ConfirmForgotPasswordRequest {
  return {
    type: ForgotPasswordActionTypes.CONFIRM_FORGOT_PASSWORD_REQUEST,
    username,
    verificationCode,
    newPassword,
    userPool,
  } as ConfirmForgotPasswordRequest;
}

export function confirmForgotPasswordSuccess(): ConfirmForgotPasswordSuccess {
  return {
    type: ForgotPasswordActionTypes.CONFIRM_FORGOT_PASSWORD_SUCCESS,
  } as ConfirmForgotPasswordSuccess;
}

export function confirmForgotPasswordFailed(error: any): ConfirmForgotPasswordError {
  return {
    type: ForgotPasswordActionTypes.CONFIRM_FORGOT_PASSWORD_ERROR,
    error,
  } as ConfirmForgotPasswordError;
}

export function setForgotPasswordField(
  field: 'email' | 'verificationCode' | 'newPassword' | 'confirmPassword',
  value: string
): SetForgotPasswordField {
  return {
    type: ForgotPasswordActionTypes.SET_FORGOT_PASSWORD_FIELD,
    field,
    value,
  };
}

export interface VerifyCodeRequest {
  type: ForgotPasswordActionTypes.VERIFY_CODE_REQUEST;
}

export function verifyCode(): VerifyCodeRequest {
  return {
    type: ForgotPasswordActionTypes.VERIFY_CODE_REQUEST,
  };
}

export type ForgotPasswordAction =
  | ForgotPasswordRequest
  | ForgotPasswordSuccess
  | ForgotPasswordError
  | ConfirmForgotPasswordRequest
  | ConfirmForgotPasswordSuccess
  | ConfirmForgotPasswordError
  | SetForgotPasswordField
  | VerifyCodeRequest;

